<template>
  <div class="simple-chart">
    <div v-if="!data || data.length === 0" class="text-center text-muted py-4">
      Nenhum dado disponível
    </div>
    <div v-else>
      <div 
        v-for="(item, index) in data" 
        :key="index"
        class="chart-bar mb-2"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span class="chart-label">{{ getLabel(item) }}</span>
          <span class="chart-value">{{ getValue(item) }}</span>
        </div>
        <div class="progress" style="height: 20px;">
          <div 
            class="progress-bar" 
            :style="getBarStyle(item, index)"
            role="progressbar"
          >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleChart',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'bar', // bar, percentage
      validator: value => ['bar', 'percentage'].includes(value)
    },
    colors: {
      type: Array,
      default: () => ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#C9CBCF']
    },
    labelField: {
      type: String,
      default: 'label'
    },
    valueField: {
      type: String,
      default: 'value'
    },
    maxValue: {
      type: Number,
      default: null
    }
  },
  computed: {
    calculatedMaxValue() {
      if (this.maxValue !== null) return this.maxValue
      if (this.type === 'percentage') return 100
      return Math.max(...this.data.map(item => this.getValue(item)))
    }
  },
  methods: {
    getLabel(item) {
      if (typeof item === 'object') {
        let label = item[this.labelField] || item.label || item.name || item.tool_name || 'N/A'
        
        // Formatar datas
        if (this.labelField === 'data' && label !== 'N/A') {
          const date = new Date(label)
          if (!isNaN(date.getTime())) {
            label = date.toLocaleDateString('pt-BR')
          }
        }
        
        // Formatar horas
        if (this.labelField === 'hora' && label !== 'N/A') {
          label = `${label}:00`
        }
        
        return label
      }
      return item
    },
    getValue(item) {
      if (typeof item === 'object') {
        const value = item[this.valueField] || item.value || item.total || item.taxa_sucesso || 0
        if (this.type === 'percentage') {
          return `${value.toFixed(1)}%`
        }
        return value
      }
      return item
    },
    getBarStyle(item, index) {
      let value = 0
      if (typeof item === 'object') {
        value = item[this.valueField] || item.value || item.total || item.taxa_sucesso || 0
      } else {
        value = item
      }

      const percentage = this.calculatedMaxValue > 0 ? (value / this.calculatedMaxValue * 100) : 0
      let color = this.colors[index % this.colors.length]

      // Para taxa de sucesso, usar cores baseadas no valor
      if (this.type === 'percentage' && typeof item === 'object' && item.taxa_sucesso !== undefined) {
        color = value >= 80 ? '#28a745' : value >= 60 ? '#ffc107' : '#dc3545'
      }

      return {
        width: `${percentage}%`,
        backgroundColor: color
      }
    }
  }
}
</script>

<style scoped>
.simple-chart {
  min-height: 200px;
}

.chart-bar {
  padding: 0.25rem 0;
}

.chart-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #495057;
}

.chart-value {
  font-size: 0.875rem;
  font-weight: 600;
  color: #212529;
}

.progress {
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.progress-bar {
  transition: width 0.6s ease;
  border-radius: 0.25rem;
}

.eloca-theme-dark .chart-label {
  color: #ffffff !important;
}

.eloca-theme-dark .chart-value {
  color: #ffffff !important;
}

.eloca-theme-dark .progress {
  background-color: #495057 !important;
}
</style>
